import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'delkeskamp',
} as IModuleProps;
